/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AppointmentCandidateShadow/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import Selected from './Selected/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function AppointmentCandidateShadow({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/AppointmentCandidateShadow"
  
}) {
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtColorsGreen700alpha50 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700alpha.50'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let eventValueData = fromData.useDataFormat({ viewPath,
context: 'event',
format: fromFormat.formatTimegridAppointmentTime,
})
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let eventDescriptionValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'description',
})
  return (<React.Fragment
>
<div
  data-testid="AppointmentCandidateShadow.Vertical"
  data-view-path={viewPath}
 style={{'--bblr-1-e1ceL': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--bbrr-2-e1ceL': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--btlr-3-e1ceL': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--btrr-4-e1ceL': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--bc-5-e1ceL': dtColorsGreen700alpha50,'--bc-6-e1ceL': dtColorsGreen700alpha50}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="AppointmentCandidateShadow.Vertical:1"
  data-view-path={viewPath}
 style={{'--pt-7-e1ceL': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pr-8-e1ceL': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-9-e1ceL': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pl-10-e1ceL': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="AppointmentCandidateShadow.Vertical:2"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsWhite}
 data="event"
 format="/Data/format.js formatTimegridAppointmentTime"
 text={eventValueData}
 weight="medium"
 size="small"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsWhite}
 data="event.description"
 text={eventDescriptionValueData}
 weight="medium"
 size="small"
/>
</div>
<Selected
  viewPath={`${viewPath}/Selected`}
/>
</div>
</div>
{children}
</React.Fragment>)
}